import { defineMessages } from 'react-intl';

export default defineMessages({
  success: {
    id: 'admin.notifications.success',
    description: 'Notification Successs Message',
    defaultMessage: 'Success!',
  },
  error: {
    id: 'admin.notifications.error',
    description: 'Notification Error Message',
    defaultMessage: 'An error ocurred',
  },
});
